export default "images/road.png";